/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseUserSearchOptionsResponse
 */
export interface ResponseUserSearchOptionsResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponseUserSearchOptionsResponse
     */
    baseId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseUserSearchOptionsResponse
     */
    firstName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseUserSearchOptionsResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseUserSearchOptionsResponse
     */
    lastName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseUserSearchOptionsResponse
     */
    permissionId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseUserSearchOptionsResponse
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseUserSearchOptionsResponse
     */
    userNumber?: number;
}

/**
 * Check if a given object implements the ResponseUserSearchOptionsResponse interface.
 */
export function instanceOfResponseUserSearchOptionsResponse(value: object): value is ResponseUserSearchOptionsResponse {
    return true;
}

export function ResponseUserSearchOptionsResponseFromJSON(json: any): ResponseUserSearchOptionsResponse {
    return ResponseUserSearchOptionsResponseFromJSONTyped(json, false);
}

export function ResponseUserSearchOptionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUserSearchOptionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'id': json['id'] == null ? undefined : json['id'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'permissionId': json['permission_id'] == null ? undefined : json['permission_id'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userNumber': json['user_number'] == null ? undefined : json['user_number'],
    };
}

export function ResponseUserSearchOptionsResponseToJSON(json: any): ResponseUserSearchOptionsResponse {
    return ResponseUserSearchOptionsResponseToJSONTyped(json, false);
}

export function ResponseUserSearchOptionsResponseToJSONTyped(value?: ResponseUserSearchOptionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'first_name': value['firstName'],
        'id': value['id'],
        'last_name': value['lastName'],
        'permission_id': value['permissionId'],
        'tenant_id': value['tenantId'],
        'user_number': value['userNumber'],
    };
}

